module.exports = __webpack_public_path__ + "static/media/35-brekraftstrategi.618a114c.mp3";